import { DraftInvoiceJobConflict } from '@aiwyn/gql-api/src/models/response/draft-invoice-job-conflict.model';
import { ConflictingDraftInvoice } from '../../../../../api/models/invoice-reversal-eligibility.models';

export class InvoiceReversalConflictMapper {
  static toConflictingDraftInvoices(conflicts: DraftInvoiceJobConflict[] | null | undefined): ConflictingDraftInvoice[] {
    if (!conflicts) {
      return [];
    }

    return conflicts.map((conflict) => this.toConflictingDraftInvoice(conflict));
  }

  static toConflictingDraftInvoice(conflict: DraftInvoiceJobConflict): ConflictingDraftInvoice {
    return {
      draftInvoiceId: conflict.draftInvoiceId,
      projectId: conflict.jobId,
      projectName: conflict.jobName,
    };
  }
}
